// extracted by mini-css-extract-plugin
export default {"form":"SearchBar_form__t6Egk","input":"SearchBar_input__XTp4A","button":"SearchBar_button__flOKM"};